import type { paths } from '@/lib/api/generated';

export const DASHBOARD_PERIOD_OPTIONS = ['today', 'yesterday', '7d', '30d', 'custom'] as const;

export type DashboardPeriod = (typeof DASHBOARD_PERIOD_OPTIONS)[number];
export type MerchantSummaryPeriod = DashboardPeriod;
export type ReceiptStatusFilter = 'pending' | 'done' | 'failed';

export const DASHBOARD_PERIOD_LABELS: Record<DashboardPeriod, string> = {
  today: 'Today',
  yesterday: 'Yesterday',
  '7d': '7d',
  '30d': '30d',
  custom: 'Custom',
};

export type MerchantSummaryResponse =
  paths['/api/v1/merchant/summary']['get']['responses']['200']['content']['application/json'];
export type MerchantSummarySnapshot = MerchantSummaryResponse['period_now'];

type MerchantReceiptsOperation = paths['/api/v1/merchant/receipts']['get'];

export type MerchantReceiptsResponse =
  MerchantReceiptsOperation['responses']['200']['content']['application/json'];
export type MerchantReceiptItem = MerchantReceiptsResponse['items'][number];

type MerchantDevicesHealthOperation = paths['/api/v1/merchant/devices/health']['get'];
type MerchantDisplaySelfTestOperation =
  paths['/api/v1/merchant/devices/{device_id}/test-display']['post'];

export type MerchantDevicesHealthResponse =
  MerchantDevicesHealthOperation['responses']['200']['content']['application/json'];
export type MerchantDeviceHealthItem = MerchantDevicesHealthResponse['devices'][number];
export type MerchantDisplaySelfTestResponse =
  MerchantDisplaySelfTestOperation['responses']['200']['content']['application/json'];

export interface MerchantSummaryQueryParams {
  period: MerchantSummaryPeriod;
  from?: string;
  to?: string;
  branch_id?: string;
}

export type MerchantReceiptsQueryParams = NonNullable<MerchantReceiptsOperation['parameters']['query']>;
export type MerchantDevicesHealthQueryParams = NonNullable<
  MerchantDevicesHealthOperation['parameters']['query']
>;
